import React from "react";
import { createComponent } from "@lit/react";
import { BeamImpactOverview as _BeamImpactOverview } from "./index";

export const BeamImpactOverview = createComponent({
  tagName: _BeamImpactOverview.tagName,
  elementClass: _BeamImpactOverview,
  react: React,
  events: {},
});

export default BeamImpactOverview; // default alias for use with async import utils like next/dynamic and react.lazy
